// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wsbLq","controls":"styles_controls__3UESz","charLimit":"styles_charLimit__1NDGa","input":"styles_input__a6Nnr","send":"styles_send__2YjpM"};